import { render, staticRenderFns } from "./iconChip.vue?vue&type=template&id=5daa3800"
import script from "./iconChip.vue?vue&type=script&lang=js"
export * from "./iconChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports